export enum CompanyRoutingEnum {
  Root = ':companyId',
}

export enum CompanyRoutingFragmentEnum {
  Presentation = '',
  Jobs = 'jobs',
  PartnersJobs = 'jobs-des-partenaires',
  News = 'news',
}
